import React from 'react'
import ProductPage from '../../component/ProductSales/ProductSalesPage/ProductPage'
import FloatingContactUs from '../../component/floting_contact/FloatingContactUs'
import { Helmet } from "react-helmet-async";
const ProductSalePage = () => {
  return (
    <>
      {/* ✅ Meta Tags for SEO */}
   <Helmet>
      <title>PLM Product Sales & Solutions in Pune | Nextech PLM</title>
      <meta name="description" content="Explore and purchase advanced PLM products and solutions in Pune, India. Nextech PLM delivers reliable products for efficient business operations." />
      <meta name="keywords" content="PLM product sales Pune, Teamcenter licenses, Siemens PLM products India, buy PLM software, NexTech PLM products, engineering software sales" />
      <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      <link rel="canonical" href="https://nextechplm.com/product-sales" />
      <meta property="og:site_name" content="NexTech PLM Solutions" />
      <meta property="og:type" content="website" />
      <meta property="og:title" content="PLM Product Sales & Solutions in Pune | Nextech PLM" />
      <meta property="og:description" content="Explore and purchase advanced PLM products and solutions in Pune, India. Nextech PLM delivers reliable products for efficient business operations." />
      <meta property="og:url" content="https://nextechplm.com/product-sales" />
      <meta property="og:image" content="https://nextechplm.com/logo192.png" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="PLM Product Sales & Solutions in Pune | Nextech PLM" />
      <meta name="twitter:description" content="Explore and purchase advanced PLM products and solutions in Pune, India. Nextech PLM delivers reliable products for efficient business operations." />
      <meta name="twitter:image" content="https://nextechplm.com/logo192.png" />
   </Helmet>

      
    <div>
      <ProductPage/>
      <FloatingContactUs />
    </div>
    </>
  )
}

export default ProductSalePage
